import Vue from 'vue';
import Vuex from 'vuex';
import CategoriesModule from './categories/store-module';
import AuthorizationModule from './authorization/store-module';
import TopicsModule from './topics/store-module';
import miscModule from './misc/store-module';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    categories: CategoriesModule,
    topics: TopicsModule,
    authorization: AuthorizationModule,
    misc: miscModule
  },
  state: {},
  mutations: {},
  actions: {}
});

export default store;
